module.exports = __webpack_public_path__ + "media/images/icon__arrow-left-522609105c30d6f32fe3bd24fd5b71a3.png";